export default {
  GET_PENDING_INVESTOR_GOAL_MOVEMENTS_QUERY: Symbol.for('GET_PENDING_INVESTOR_GOAL_MOVEMENTS_QUERY'),
  PENDING_INVESTOR_GOAL_MOVEMENTS_REPOSITORY: Symbol.for('PENDING_INVESTOR_GOAL_MOVEMENTS_REPOSITORY'),
  PENDING_INVESTOR_GOAL_MOVEMENTS_STATE_MANAGER: Symbol.for('PENDING_INVESTOR_GOAL_MOVEMENTS_STATE_MANAGER'),
};
